/* global $:true */
import debug from "debug";
import plugin from '../../lib/plugin';

const MODULE_NAME = 'app.core/modules/available-colour-swatches';
const log = debug(MODULE_NAME);
const ELEMENT_SELECTOR = '[data-available-colour-swatches]';
const QUOTE_ONLY_SELECTOR = '[data-product-detail-page-is-quote-only]';
const QUOTE_ONLY_ATTR = 'data-product-detail-page-is-quote-only';
const SELECT_FIELD_SELECTOR = '[data-colour-list]';
const IDENTIFIER_SELECTOR = '[data-identifier]';
const IDENTIFIER = 'data-identifier';

class AvailableColourSwatches {

	constructor (element, options) {
		this.element = element;
		this.options = options;
		this.$element = $(element);
		this.$colourLists = $(SELECT_FIELD_SELECTOR);
		this.$colourSwatches = $(IDENTIFIER_SELECTOR);
		this.isQuoteOnly =$(QUOTE_ONLY_SELECTOR).attr(QUOTE_ONLY_ATTR) == 'true';
		log('AvailableColourSwatches', element);
		this.init();
	}

	init () {
		if (this.$colourLists.length > 0) {
			var allHexes = new Array();
			for(var i =0; i < this.$colourLists.length; i++) {
				var list = this.$colourLists[i];
				var hexes = $(list).find(IDENTIFIER_SELECTOR);
				for(var j=0;j<hexes.length;j++) {
					var hex = $(hexes[j]).attr(IDENTIFIER);
					if (allHexes.indexOf(hex) < 0 && hex.length > 0) {
						allHexes.push(hex);
					}
				}
			}
			var numberHidden = 0;
			for(var i=0;i<this.$colourSwatches.length;i++) {
				var hexVal = $(this.$colourSwatches[i]).attr(IDENTIFIER);
				if (allHexes.indexOf(hexVal) < 0 ) {
					$(this.$colourSwatches[i]).parent().hide();
					numberHidden++;
				}
			}

			if (numberHidden == this.$colourSwatches.length) {
				this.$element.parent().hide();
			}
		}
		// STRONE-762 - if no colour codes, don't show colour swatches
		// STRONE-769 - if quote only don't hide the colour swatches
		else if (!this.isQuoteOnly){
			this.$element.parent().hide();
		}
	}
}

AvailableColourSwatches.DEFAULTS = {
};


plugin('availableColourSwatches', AvailableColourSwatches);

export function exec () {
	$(document).ready(() => {
		log('binding');
		$(ELEMENT_SELECTOR).availableColourSwatches();
		log('bound');
	});
}



// WEBPACK FOOTER //
// ./project/client/src/core/modules/available-colour-swatches/index.js